export default __webpack_public_path__ + "static/media/R5C_8176.a26a4c89.jpg";